import { actions as collection } from '@/plugins/Collection'

const options = []

for (let time = 8; time < 19; time++) {
  options.push(`${time}:00`)
  options.push(`${time}:30`)
}

export default collection.toOptions(options)
